<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
         <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <ECMErrorDialog ref="messageDlg" v-model="messageDlg"/>
            <b-col>
                <h1>{{ecmResourceStrings.ttlSMTPNotifications}} (Repository ID : {{id}}; Type : {{type}})</h1>
            </b-col>
            <b-col class="text-right OTbtnContainer" cols="4" >
                 <otif-button class="OTSecondary"  @click.native="back" id="otBack" >{{ecmResourceStrings.lblBack}}</otif-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <otif-ecm-table
                :rows="notificationdata"
                :columns="dashboardcolumns"
                :actions="dashboardactions"
                :paginated="false"
                :customOptions="customOptions"
                :columnlabel="columnlabel">
            </otif-ecm-table>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>


import axios from 'axios';
import { showMessage} from '../../../utils/commonECM.js';
import ECMErrorDialog from '../../modals/ECMCrawlerMessageDlg.vue';
import StatusColumn from '../../links/dashboardstatus.vue';


export default {

    props: {
        id:{
            required: true
        },
        type:{
            required: true
        },
    },

    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),   
            messageDlg:false,
            loaded: false,
            customOptions:  [],
            status_changed:false,
            columnlabel:"",
            dashboardcolumns: [{
                name: 'name',
                label: 'Name',
                sortable: false,
                editable:false,
                render(row) {
                    return row.name;
                }
            },{
                name: 'timestamp',
                label: 'Date of last update',
                sortable: false,
                editable:false,
                render(row) {
                    return row.timestamp;
                }
            },{
                name: 'status',
                label: 'Status',
                sortable: false,
                editable:false,
                displayComponent:StatusColumn,
            },{
                name: 'text',
                sortable: false,
                editable:false,
                render(row) {
                    return row.text;
                }
            }]
            ,
            dashboardactions:[{
                name: 'verify',
                label: 'Verify Status',
                callback: this.onVerifySMTPNotification
            },{
                name: 'start',
                label: 'Start Notifications',
                callback: this.onStartSMTPNotification
            },{
                name: 'stop',
                label: 'Stop Notifications',
                callback: this.onStopSMTPNotification
            }],
            notificationdata: [],
        }
    },

    methods: {
        refresh() {
            this.loaded = true;
        },

        back() {
            this.$router.push('/settings/ecmrepositories');
        },

        onVerifySMTPNotification()
        {
            var that = this;
            that.updateSMTPState(true,  "verify");
        },
        
        onStartSMTPNotification()
        {
            var that = this;
            
            //as soon as we can not du button disaled in context menu
            //we have chack if status is Running
            //give a message
            
            that.notificationdata[0].status ="Working";
            that.notificationdata[0].text ="Working";
            that.notificationdata[0].timestamp="";
            const connString=that.createBodyPostString("MonitorErrorLog", that.id);
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                    if (res.data && res.data.crawlerOperationDetails[0]) {
                        setTimeout(that.updateSMTPState(true,  "start"),20000);
                    }
                })
                .catch((err) => {
                    if(err.response)
                    {
                        that.notificationdata[0].text =err.response.statusText;
                        showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState,err.message, true, err.response.data);
                    }
                    else
                    {
                     that.notificationdata[0].text =err.message;
                    }
                    
                    //that.updateSMTPState(false,  "verify");
                    that.notificationdata[0].status ="CommunicationError";
                    const d = new Date();
                    that.notificationdata[0].timestamp="on " + d;
            });             
        },

        onStopSMTPNotification()
        {
            var that = this;
            that.notificationdata[0].status ="Working";
            that.notificationdata[0].text ="Working";
            const d = new Date();
            that.notificationdata[0].timestamp="";
                                    
            const connString=that.createBodyPostString("StopMonitorErrorLog", that.id);
           
            axios.post('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess', connString, 
                {headers: {"Content-Type": "application/json; charset=UTF-8"}})
                .then((res) => {
                   if (res.data && res.data.crawlerOperationDetails[0]) {
                        setTimeout(that.updateSMTPState(false , "stop"),20000);
                    }
                    else{
                        //communication error probably
                    }
                })
                .catch((err) => {
                    //verify todo
                    that.updateSMTPState(false,  "verify");
                });      
        },
        
        
        async updateSMTPState(showmessage, camefrom)//action "verify", "start", "stop"
        {
            var that = this;
            that.notificationdata[0].status ="Working";
            that.notificationdata[0].text ="Working";
            that.notificationdata[0].timestamp="";
            var processName;
            if(camefrom =="start")
            {
                processName = 'MonitorErrorLog';
            }
            if(camefrom =="stop")
            {
                processName = 'StopMonitorErrorLog';
            }
            if(camefrom =="verify")
            {
                that.getStatusFromLookup(true);
                return;
            }
          //  const data = {'shRepositoryId':that.id};
            axios.get('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess?ProcessName=' + processName)
                .then((res) => {
                    if (res.data) {
                        if(res.data.crawlerExecuteProcessResultsDetails)
                        {
                            const len = res.data.crawlerExecuteProcessResultsDetails.length;
                            if(res.data.crawlerExecuteProcessResultsDetails[len-1])
                            {
                                if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails)
                                {
                                    const lenDet = res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails.length;
                                    if(lenDet > 0)
                                    {
                                        if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionStatusDetails == null)
                                        {
                                            that.notificationdata[0].status ="NotRunning";
                                            that.notificationdata[0].text ="Not Running";
                                            const d = new Date();
                                            that.notificationdata[0].timestamp="on " + d;
                                        }
                                        else
                                        {
                                            if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionStatusDetails.status=="Finished")
                                            {
                                                if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionLogDetails.status == "Error")
                                                {
                                                    if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionExceptionDetails
                                                    && res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionExceptionDetails[0])
                                                    {
                                                        that.notificationdata[0].status ="Error";
                                                        that.notificationdata[0].text ="Error";
                                                        const d = new Date();
                                                        that.notificationdata[0].timestamp="on " + d;
                                                        const error = res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionExceptionDetails[0].description;
                                                        showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState, "Error", true, error);
                                                    }
                                                    else
                                                    {
                                                        that.notificationdata[0].status ="Error";
                                                        that.notificationdata[0].text ="Error";
                                                        const d = new Date();
                                                        that.notificationdata[0].timestamp="on " + d;
                                                    }
                                                    //const logId = res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionLogDetails.logId;
                                                    //if(logId > 0)
                                                    //    that.getErrors(showmessage, true, logId);
                                                }
                                                else
                                                {
                                                    that.notificationdata[0].status ="NotRunning";
                                                    that.notificationdata[0].text ="Not Running";
                                                    const d = new Date();
                                                    that.notificationdata[0].timestamp="on " + d;
                                                }

                                            }
                                            else if(res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionStatusDetails.status=="Running")
                                            {
                                                that.notificationdata[0].status ="Running";
                                                that.notificationdata[0].text ="Running";
                                                const d = new Date();
                                                that.notificationdata[0].timestamp="on " + d;
                                            }
                                            else
                                            {
                                                const logId = res.data.crawlerExecuteProcessResultsDetails[len-1].executionResultsDetails[lenDet-1].executionLogDetails.logId;
                                                if(logId > 0)
                                                    that.getErrors(showmessage, true, logId);
                                            }
                                        }
                                    }
                                }
                                else
                                {
                                    //can not get status
                                    that.notificationdata[0].status ="CommunicationError";
                                    that.notificationdata[0].text ="No Info";
                                    const d = new Date();
                                    that.notificationdata[0].timestamp="on " + d;
                                }   
                            }
                            else
                            {
                                //it means method on thin machine is not completed. never should be here, but just in case
                                that.notificationdata[0].status ="CommunicationError";
                                that.notificationdata[0].text ="No Info";
                                const d = new Date();
                                that.notificationdata[0].timestamp="on " + d;
                            }
                        }
                        else{
                            //it means method on thin machine is not completed. never should be here, but just in case
                            that.notificationdata[0].status ="CommunicationError";
                            that.notificationdata[0].text ="No Info";
                            const d = new Date();
                            that.notificationdata[0].timestamp="on " + d;
                        }
                }
            })
            .catch((err) => {
                //can not get status at all
                that.notificationdata[0].status ="CommunicationError";
                that.notificationdata[0].text =err.response.statusText;
                const d = new Date();
                that.notificationdata[0].timestamp="on " + d;
                if(showmessage == true)
                {
                    showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState,err.response.statusText, true, err.response.data);
                }
            });
        },

        createBodyPostString(name, id)
        {
            const parameters = '[{ "name" : "shRepositoryId", "value" : '+ id +', "type" : "int","isNull" : false}]';
            var configstring = '{"name": "' + name + '", "engineName": "1", "parameters": ' + parameters + ', "asynchronousExecution": true}';
            return configstring;
        },
        
        getStatusFromLookup(showmessage)
        {
            /*OTIC Look up table ManageErrorMonitoring contains status for monitoring repositories
            Field from the table ISRun: 0 - Monitoring for the repository is not running , 1 - Monitoring is running  
            If record in the table is missing – Monitoring is not running.*/
            var that = this;
            that.notificationdata[0].status ="Working";
            that.notificationdata[0].text ="Working";
            that.notificationdata[0].timestamp="";

                axios.get('/mtm-gateway-api/v1/services/ecm/query/manageErrorMonitoring/' + that.id)
                 .then((res) => {
                if(res)
                {
                    const d = new Date();
                    that.notificationdata[0].timestamp="on " + d;
                    if(res.status == 200) //OK
                    {
                        if(res.data && res.data.db_records)
                        {
                            const len = res.data.db_records.length;
                            if(len > 0)
                            {
                                const iter = len - 1;
                                for(var i =iter; i > -1; i--)
                                {
                                    const oneArray = res.data.db_records[iter];
                                    if(oneArray)
                                    {
                                        if(oneArray.db_fields && oneArray.db_fields.length == 3)//there is 3 columns in lookup table
                                        {
                                            const ecmdata = oneArray.db_fields[0].db_field_properties;
                                            const stopdata = oneArray.db_fields[1].db_field_properties;
                                            const rundata = oneArray.db_fields[2].db_field_properties;
                                            if(ecmdata && stopdata && rundata)
                                            {
                                                if(ecmdata.value == that.id)
                                                {
                                                    const stopFlag = stopdata.value;
                                                    const runningFlag = rundata.value;
                                                    if(runningFlag == 0)
                                                    {//ISRun: 0 - Monitoring for the repository is not running
                                                        that.notificationdata[0].status ="NotRunning";
                                                        that.notificationdata[0].text ="Not Running";
                                                    }
                                                    else if(runningFlag == 1)
                                                    {// 1 - Monitoring is running
                                                        if(stopFlag == 0)
                                                        {
                                                            that.notificationdata[0].status ="Running";
                                                            that.notificationdata[0].text ="Running";
                                                        }
                                                        else
                                                        {//still running but flag stop is already on
                                                            that.notificationdata[0].status ="NotRunning";
                                                            that.notificationdata[0].text ="Not Running";
                                                        }
                                                    }
                                                    break;
                                                }
                                                else
                                                {
                                                    continue;
                                                }
                                            }
                                            else
                                            {
                                                that.notificationdata[0].status ="Error";
                                                that.notificationdata[0].text ="Corrupted data";
                                            }
                                        }
                                        else
                                        {
                                            that.notificationdata[0].status ="Error";
                                            that.notificationdata[0].text ="Invalid data";
                                        }
                                    }
                                    else
                                    {
                                        that.notificationdata[0].status ="CommunicationError";
                                        that.notificationdata[0].text ="Can not get status";
                                    }
                                }
                            }
                            else
                            {
                                that.notificationdata[0].status ="NotRunning";
                                that.notificationdata[0].text ="Not Running";
                            }
                        }
                        else
                        {
                            that.notificationdata[0].status ="NotRunning";
                            that.notificationdata[0].text ="Not Running";
                        }
                    }
                    else
                    {
                        that.notificationdata[0].status ="Error";
                        that.notificationdata[0].text ="Error";
                    }
                }
            
            })
            .catch((err) => {
                //can not get status at all
                const d = new Date();
                that.notificationdata[0].timestamp="on " + d;
                that.notificationdata[0].status ="CommunicationError";
                if(err.response)
                {that.notificationdata[0].text =err.response.statusText;
                }
                else{
                    if(err.message)
                    {
                    that.notificationdata[0].text=err.message;
                    }
                    else{
                        that.notificationdata[0].text="Unknown error";
                    }
                }
                const d2 = new Date();
                that.notificationdata[0].timestamp="on " + d2;
               // if(showmessage == true)
               // {//todo
               //     showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState,err.response.statusText, true, err.response.data);
               // }
            });
        },


        getErrors:function(showmessage, running, logid)
        {
            var that = this;
            axios.get('/mtm-gateway-api/v1/services/ecm/query/errorLog/' + logid)
                .then((res) => {
                    if (res.data) {
                        if(res.data.logDetails)
                        {
                            //errors are exists
                            const comp = res.data.logDetails[0].component;
                            const mess = res.data.logDetails[0].message;
                            const eachLine = mess.split('\n');
                            const lines = eachLine.length;
                            const main = eachLine[0];
                            var mesdata = '';
                            that.errorDescription ='';
                            if(mess)
                            {
                                if(main)
                                {
                                    if(main.length > 150)
                                    {
                                        mesdata="Error";
                                    }
                                else
                                {
                                    mesdata=main;
                                }
                            }
                            else
                            {
                                mesdata = mess;
                            }
                            var infotext = "";
                            if(comp)
                            {
                                infotext = that.ecmResourceStrings.errCcomponent + comp + that.ecmResourceStrings.errMessage + mesdata;
                            }
                            else
                            {
                                infotext = mesdata;
                            }  
                            that.notificationdata[0].status ="Error";
                            that.notificationdata[0].text =infotext;
                            const d = new Date();
                            that.notificationdata[0].timestamp="on " + d;
                            if(showmessage == true)
                            {
                                showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState,'', true, mess);
                            }
                         }
                     }
                     else
                     { //running or not running with no errors
                        if(running == true)
                        {
                            that.notificationdata[0].status ="Running";
                            that.notificationdata[0].text ="Running";
                            const d = new Date();
                            that.notificationdata[0].timestamp="on " + d;
                            if(showmessage == true)
                            {
                                showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState,'', true, that.ecmResourceStrings.msgSMTPRunning);
                            }
                        }
                        else
                        {
                            that.notificationdata[0].status ="NotRunning";
                            that.notificationdata[0].text ="Not Running";
                            const d = new Date();
                            that.notificationdata[0].timestamp="on " + d;
                            if(showmessage == true)
                            {
                                showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState,'', true, that.ecmResourceStrings.msgSMTPNotRunning);
                            }
                        }
                    }
                }
            })
            .catch((err) => {
                //can not get status at all
                that.notificationdata[0].status ="CommunicationError";
                if(err.response)
                {that.notificationdata[0].text =err.response.statusText;
                }
                else{
                    that.notificationdata[0].text="";
                }
                const d = new Date();
                that.notificationdata[0].timestamp="on " + d;
                if(showmessage == true)
                {//todo
                    showMessage(this, 'info', that.ecmResourceStrings.ttlSMTPNotificationState,err.response.statusText, true, err.response.data);
                }
            });
        },
    },    

       

       

    components: {
        ECMErrorDialog
    },

    mounted() {
        var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'ecm-repositories',
            meta: { label: 'Repositories' }
        },{
            name: 'ecm-repo-smtp-notification',
            meta: { label: 'SMTP notifications ' }
        }];
        this.$store.commit('breadcrumbs', breadcrumbs);
    },

    async created() {
        var that = this;
        that.notificationdata=[];
        that.notificationdata.push({
            "name":that.ecmResourceStrings.lblSMTP,
            "timestamp":"",
            "status" : "",
            "text" : ""});

        try
        {
            //Henry call from lookup data
            /*const res = await axios.get('/mtm-gateway-api/v1/services/ecm/actions/CrawlerExecuteProcess?ProcessName=')
            that.notificationdata[0].status ="NotRunning";
            that.notificationdata[0].text ="Not Running";
            const d = new Date();
            that.notificationdata[0].timestamp="on " + d;;*/
            this.loaded = true;
        } 
        catch (e)
        {
                this.loaded = true;
        }
        //that.updateSMTPState(false,  "verify");   
        that.getStatusFromLookup(false);
    }
}

</script>
